// Season 1 starts at 12:10 AM UTC on 2024-11-08
export const SEASON_1_START_DATE=new Date('2024-11-08T00:10:00Z');// Season 2 starts at 12:10 AM UTC on 2024-12-27
export const SEASON_2_START_DATE=new Date('2024-12-27T00:10:00Z');